
const fr = {
  // Common
  common: {
    learnMore: 'En Savoir Plus',
    getStarted: 'Commencer',
  },

  // Navigation
  nav: {
    home: 'Accueil',
    about: 'À Propos',
    services: 'Services',
    solutions: 'Solutions',
    blog: 'Blog',
    contact: 'Contact',
    getStarted: 'Commencer',
    login: 'Connexion',
  },

  // Home Page
  home: {
    hero: {
      badge: 'Leader en Innovation Numérique',
      title: 'Solutions Numériques',
      subtitle: 'Nous transformons vos idées en solutions numériques puissantes. Développement de logiciels sur mesure, applications web et mobiles, et services de conseil informatique à Lubumbashi.',
      cta: 'Commencer',
      learnMore: 'En Savoir Plus',
      stat1: 'Clients Satisfaits',
      stat2: 'Taux de Satisfaction',
      stat3: 'Années d\'Expérience',
      card1Title: 'Développement Sur Mesure',
      card1Desc: 'Solutions adaptées à vos besoins',
      card2Title: 'Sécurisé & Fiable',
      card2Desc: '99,9% de disponibilité garantie',
    },
    trust: {
      title: 'Approuvé par les Entreprises Leaders',
      partners: 'Partenaires Technologiques',
      certifications: 'Certifications',
      satisfaction: 'Satisfaction Client',
      stats: {
        clients: 'Clients Satisfaits',
        projects: 'Projets Réalisés',
        satisfaction: 'Satisfaction Client',
        experience: 'Années d\'Expérience',
      },
    },
    value: {
      title: 'Pourquoi Choisir',
      titleHighlight: 'LogiqSoft',
      description: 'Nous offrons des solutions numériques innovantes qui stimulent la croissance des entreprises et l\'excellence opérationnelle',
      established: 'Fondé en',
      satisfactionRate: 'Taux de Satisfaction Client',
      standards: 'Normes Internationales',
      isoCompliant: 'Conforme ISO',
      features: {
        expertise: {
          title: 'Expertise Technique',
          description: 'Notre équipe de développeurs et consultants expérimentés apporte une connaissance technique approfondie sur plusieurs plateformes et technologies.',
        },
        quality: {
          title: 'Assurance Qualité',
          description: 'Nous suivons les meilleures pratiques de l\'industrie et des procédures de test rigoureuses pour garantir des solutions fiables et performantes.',
        },
        support: {
          title: 'Support Dédié',
          description: 'Support technique et services de maintenance 24h/24 et 7j/7 pour maintenir vos systèmes en bon état de fonctionnement à tout moment.',
        },
        innovation: {
          title: 'Focus sur l\'Innovation',
          description: 'Nous restons à la pointe des tendances technologiques pour fournir des solutions de pointe qui vous donnent un avantage concurrentiel.',
        },
      },
    },
    services: {
      title: 'Nos',
      titleHighlight: 'Services',
      description: 'Solutions numériques complètes adaptées aux besoins de votre entreprise',
      subtitle: 'Solutions numériques complètes adaptées aux besoins de votre entreprise',
      custom: 'Logiciels Sur Mesure',
      customDesc: 'Solutions logicielles sur mesure conçues pour résoudre vos défis commerciaux uniques et rationaliser les opérations.',
      customFeatures: {
        webApps: 'Applications Web Sur Mesure',
        mobile: 'Solutions Mobiles',
        desktop: 'Logiciels de Bureau',
        api: 'Intégration API',
      },
      cloud: 'Support IT & Cloud',
      cloudDesc: 'Maintenez vos systèmes en bon état de fonctionnement avec nos services complets de support IT et d\'infrastructure cloud.',
      cloudFeatures: {
        monitoring: 'Surveillance 24/7',
        network: 'Gestion de Réseau',
        cloud: 'Solutions Cloud',
        security: 'Services de Sécurité',
      },
      mobile: 'Marketing Digital',
      mobileDesc: 'Boostez la visibilité de votre marque et stimulez les conversions avec nos stratégies de marketing digital basées sur les données.',
      mobileFeatures: {
        seo: 'Optimisation SEO',
        social: 'Réseaux Sociaux',
        content: 'Stratégie de Contenu',
        analytics: 'Analyses & Rapports',
      },
      items: {
        webDev: {
          title: 'Développement Web',
          description: 'Sites web et applications web personnalisés construits avec des technologies modernes pour des performances optimales et une expérience utilisateur exceptionnelle.',
        },
        mobileDev: {
          title: 'Développement Mobile',
          description: 'Applications mobiles natives et multiplateformes pour iOS et Android qui engagent les utilisateurs et génèrent des résultats commerciaux.',
        },
        software: {
          title: 'Logiciels Sur Mesure',
          description: 'Solutions logicielles sur mesure conçues pour résoudre vos défis commerciaux uniques et rationaliser les opérations.',
        },
        cloud: {
          title: 'Solutions Cloud',
          description: 'Infrastructure cloud évolutive et services de migration pour améliorer la flexibilité et réduire les coûts informatiques.',
        },
        iot: {
          title: 'Solutions IoT',
          description: 'Implémentations de l\'Internet des Objets pour l\'automatisation intelligente, la surveillance et la prise de décision basée sur les données.',
        },
        consulting: {
          title: 'Conseil Informatique',
          description: 'Conseil technologique stratégique pour vous aider à prendre des décisions éclairées et optimiser vos investissements informatiques.',
        },
      },
    },
    process: {
      title: 'Comment Nous',
      titleHighlight: 'Travaillons',
      description: 'Notre processus éprouvé garantit une livraison de projet réussie du concept au lancement',
      steps: {
        strategy: {
          title: 'Atelier Stratégique',
          description: 'Nous recommandons des fonctionnalités de solution et des stratégies numériques qui vous aident à atteindre vos objectifs commerciaux.',
        },
        wireframes: {
          title: 'Maquettes Filaires',
          description: 'Nous décortiquons les couches de fonctionnalités "conviviales" pour affiner la proposition de valeur fondamentale de votre solution.',
        },
        prototyping: {
          title: 'Prototypage',
          description: 'Nous développons rapidement des fonctionnalités de solution que vous pouvez expérimenter et valider.',
        },
        development: {
          title: 'Développement',
          description: 'Nous utilisons un processus de développement axé sur le design pour définir chaque écran et fonctionnalité de la solution.',
        },
      },
      delivery: 'Livraison moyenne du projet : 4 à 8 semaines',
    },
    caseStudies: {
      title: 'Histoires de',
      titleHighlight: 'Succès',
      description: 'Des résultats réels de projets réels qui ont fait la différence',
      items: {
        irrigation: {
          title: 'Système d\'Irrigation Automatique',
          category: 'Environnement & Agriculture',
          description: 'Développement d\'un système d\'irrigation automatique basé sur l\'IoT qui a réduit la consommation d\'eau de 40% tout en améliorant les rendements des cultures pour les clients agricoles.',
          results: ['40% d\'Économie d\'Eau', '25% d\'Augmentation du Rendement', 'Surveillance en Temps Réel'],
          tech: ['IoT', 'Cloud Computing', 'Application Mobile'],
        },
        tracking: {
          title: 'Logiciel de Suivi de Véhicules',
          category: 'Transport & Logistique',
          description: 'Construction d\'une solution complète de suivi de véhicules présentée à la FEC, permettant la gestion de flotte en temps réel et l\'optimisation des itinéraires pour les entreprises de transport.',
          results: ['30% de Réduction des Coûts', 'GPS en Temps Réel', '99,9% de Disponibilité'],
          tech: ['Intégration GPS', 'Tableau de Bord Web', 'Applications Mobiles'],
        },
        erp: {
          title: 'Planification des Ressources d\'Entreprise',
          category: 'Gestion d\'Entreprise',
          description: 'Mise en œuvre d\'un système ERP personnalisé pour une entreprise manufacturière, rationalisant les opérations de l\'inventaire aux ventes et améliorant l\'efficacité.',
          results: ['50% de Gain de Temps', 'Plateforme Unifiée', 'Meilleures Perspectives'],
          tech: ['Logiciel Sur Mesure', 'Conception de Base de Données', 'Intégration API'],
        },
      },
      keyResults: 'Résultats Clés',
      techUsed: 'Technologies Utilisées',
    },
    testimonials: {
      title: 'Témoignages',
      titleHighlight: 'Clients',
      description: 'Découvrez ce que nos clients disent de leur collaboration avec nous',
      items: {
        testimonial1: {
          quote: 'LogiqSoft a transformé nos opérations avec leur solution ERP personnalisée. Les gains d\'efficacité ont été remarquables, et leur équipe de support est toujours là quand nous en avons besoin.',
          name: 'Jean-Pierre Mukendi',
          role: 'PDG, Mining Solutions Ltd',
          company: 'Lubumbashi',
        },
        testimonial2: {
          quote: 'Le système de suivi de véhicules qu\'ils ont développé a révolutionné notre gestion de flotte. La surveillance en temps réel et l\'optimisation des itinéraires ont réduit nos coûts de 30%.',
          name: 'Marie Kabamba',
          role: 'Directrice des Opérations',
          company: 'Transport & Logistics Co',
        },
        testimonial3: {
          quote: 'Leur solution d\'irrigation IoT a dépassé nos attentes. Le système est fiable, facile à utiliser et a considérablement amélioré notre efficacité de gestion de l\'eau.',
          name: 'David Mwamba',
          role: 'Responsable Informatique',
          company: 'Services Agricoles',
        },
        testimonial4: {
          quote: 'Les services de marketing numérique de LogiqSoft ont considérablement augmenté notre présence en ligne. Leur approche stratégique et leur attention aux détails sont exceptionnelles.',
          name: 'Sophie Kalala',
          role: 'Directrice Marketing',
          company: 'Groupe de Vente au Détail',
        },
      },
      stats: {
        clients: 'Clients Satisfaits',
        rating: 'Note Moyenne',
        retention: 'Fidélisation Client',
      },
    },
    cta: {
      title: 'Prêt à Transformer Votre Entreprise ?',
      description: 'Discutons de la façon dont nos solutions numériques peuvent vous aider à atteindre vos objectifs. Obtenez une consultation gratuite et une estimation de projet dès aujourd\'hui.',
      features: {
        response: 'Réponse Rapide',
        secure: 'Sécurisé & Fiable',
        support: 'Support 24/7',
      },
      startProject: 'Démarrer Votre Projet',
      callUs: 'Appelez-Nous Maintenant',
    },
  },

  // About Page
  about: {
    title: 'À Propos de',
    titleHighlight: 'LogiqSoft',
    subtitle: 'Autonomiser les entreprises avec des solutions numériques innovantes depuis 2019',
    story: {
      title: 'Notre Histoire',
      paragraph1: 'LogiqSoft SARL a été fondée en 2019 avec une mission claire : fournir des services et des solutions de la plus haute qualité à nos clients. Basés à Lubumbashi et Kolwezi, nous sommes devenus une équipe solide et efficace d\'experts numériques.',
      paragraph2: 'Nous nous engageons profondément à contribuer de manière significative et positive à la conception, l\'amélioration et la maintenance de vos solutions numériques de gestion, de communication, de production et de sécurité.',
      paragraph3: 'Notre expertise et nos méthodes de conception et de développement constituent le fondement de notre stratégie numérique. Vous pouvez toujours être sûr d\'obtenir des solutions numériques à jour qui répondent à vos attentes et satisfont vos exigences d\'innovation pour faire la différence face à la concurrence.',
      paragraph4: 'Nous sommes motivés et passionnés par les nouvelles technologies et la façon dont elles peuvent résoudre vos défis commerciaux.',
    },
    values: {
      title: 'Nos Valeurs Fondamentales',
      subtitle: 'Les principes qui guident tout ce que nous faisons',
      innovation: { title: 'Innovation', description: 'Nous restons à la pointe des tendances technologiques pour fournir des solutions de pointe.' },
      collaboration: { title: 'Collaboration', description: 'Nous travaillons en étroite collaboration avec les clients pour comprendre et dépasser leurs attentes.' },
      excellence: { title: 'Excellence', description: 'Nous maintenons les normes les plus élevées dans tout ce que nous livrons.' },
      integrity: { title: 'Intégrité', description: 'Nous construisons la confiance par la transparence et une communication honnête.' },
    },
    team: {
      title: 'Notre',
      titleHighlight: 'Équipe',
      subtitle: 'Rencontrez les professionnels passionnés derrière LogiqSoft',
    },
    cta: {
      title: 'Prêt à Travailler Ensemble ?',
      description: 'Discutons de la façon dont nous pouvons aider à transformer votre entreprise avec nos solutions numériques.',
      button: 'Contactez-Nous',
    },
  },

  // Services Page
  services: {
    title: 'Nos',
    titleHighlight: 'Services',
    subtitle: 'Des solutions informatiques complètes adaptées pour transformer votre entreprise et stimuler l\'innovation numérique',
    getStarted: 'Commencer',
    ctaTitle: 'Prêt à Transformer Votre Entreprise ?',
    ctaDescription: 'Discutons de la façon dont nos services peuvent vous aider à atteindre vos objectifs numériques',
    ctaButton: 'Planifier une Consultation',
    softwareDev: {
      title: 'Développement Logiciel',
      tagline: 'Solutions Logicielles Personnalisées pour Votre Entreprise',
      description: 'Nous créons des solutions logicielles puissantes et évolutives adaptées à vos besoins commerciaux uniques.',
      features: {
        title: 'Caractéristiques Clés',
        items: [
          'Applications Web Personnalisées',
          'Développement d\'Applications Mobiles (iOS & Android)',
          'Développement et Intégration d\'API',
          'Solutions Cloud-Native',
          'Architecture Microservices',
          'Applications Web Progressives (PWA)',
        ],
      },
      benefits: {
        title: 'Avantages Clés',
        performance: { title: 'Haute Performance', desc: 'Code et architecture optimisés pour des applications ultra-rapides' },
        secure: { title: 'Sécurisé et Fiable', desc: 'Sécurité de niveau entreprise et garantie de disponibilité de 99,9%' },
        responsive: { title: 'Entièrement Responsive', desc: 'Expérience fluide sur tous les appareils et plateformes' },
      },
      techTitle: 'Technologies Que Nous Utilisons',
    },
    itSupport: {
      title: 'Support et Maintenance IT',
      tagline: 'Support Technique 24/7 pour Votre Tranquillité d\'Esprit',
      description: 'Maintenez vos systèmes en bon état de fonctionnement avec nos services complets de support IT.',
      features: {
        title: 'Caractéristiques Clés',
        items: [
          'Support Help Desk 24/7',
          'Surveillance Proactive des Systèmes',
          'Gestion de Réseau',
          'Mises à Jour et Correctifs de Sécurité',
          'Sauvegarde et Récupération de Données',
          'Maintenance Matérielle et Logicielle',
        ],
      },
      benefits: {
        title: 'Avantages Clés',
        availability: { title: 'Disponibilité 24/7', desc: 'Support 24h/24 et 7j/7 quand vous en avez besoin' },
        monitoring: { title: 'Surveillance Proactive', desc: 'Identifier et résoudre les problèmes avant qu\'ils n\'impactent votre entreprise' },
        team: { title: 'Équipe d\'Experts', desc: 'Professionnels certifiés avec des années d\'expérience' },
      },
      techTitle: 'Technologies Que Nous Supportons',
    },
    digitalMarketing: {
      title: 'Marketing Digital',
      tagline: 'Développez Votre Présence en Ligne et Atteignez Plus de Clients',
      description: 'Boostez la visibilité de votre marque et stimulez les conversions avec nos stratégies de marketing digital basées sur les données.',
      features: {
        title: 'Caractéristiques Clés',
        items: [
          'Optimisation pour les Moteurs de Recherche (SEO)',
          'Marketing sur les Réseaux Sociaux',
          'Marketing de Contenu',
          'Campagnes d\'Email Marketing',
          'Publicité Pay-Per-Click (PPC)',
          'Analyses et Rapports',
        ],
      },
      benefits: {
        title: 'Avantages Clés',
        visibility: { title: 'Visibilité Accrue', desc: 'Classez-vous plus haut dans les résultats de recherche et atteignez plus de clients' },
        leads: { title: 'Plus de Prospects', desc: 'Convertissez les visiteurs en clients avec des campagnes ciblées' },
        data: { title: 'Basé sur les Données', desc: 'Prenez des décisions éclairées basées sur des analyses en temps réel' },
      },
      techTitle: 'Outils Que Nous Utilisons',
    },
    whyChoose: {
      title: 'Pourquoi Choisir',
      titleHighlight: 'LogiqSoft ?',
      description: 'Nous offrons des solutions automatisées spécialisées qui répondent aux normes internationales, aidant les entreprises à se transformer numériquement avec une technologie de pointe.',
      mobility: { title: 'Mobilité d\'Entreprise', description: 'Solutions mobiles complètes pour les entreprises modernes, permettant des opérations commerciales fluides en déplacement.' },
      iot: { title: 'Développement IoT', description: 'Connectez et automatisez vos appareils avec nos solutions avancées d\'Internet des Objets.' },
      desktop: { title: 'Logiciels de Bureau', description: 'Applications de bureau puissantes construites avec des frameworks modernes pour une performance maximale.' },
      mobileWeb: { title: 'Développement Mobile et Web', description: 'Applications web et mobiles responsives qui offrent des expériences utilisateur exceptionnelles.' },
    },
  },

  // Solutions Page
  solutions: {
    title: 'Solutions',
    titleHighlight: 'Innovantes',
    subtitle: 'Solutions technologiques de pointe conçues pour résoudre des défis commerciaux complexes et stimuler la croissance',
    keyFeatures: 'Caractéristiques Clés',
    industries: 'Industries',
    ctaTitle: 'Prêt à Mettre en Œuvre une Solution ?',
    ctaDescription: 'Discutons de la façon dont nos solutions peuvent répondre à vos défis commerciaux spécifiques',
    ctaButton: 'Commencer Aujourd\'hui',
    items: {
      mobility: {
        title: 'Solutions de Mobilité d\'Entreprise',
        description: 'Donnez du pouvoir à votre main-d\'œuvre avec des solutions mobiles qui permettent la productivité n\'importe où, n\'importe quand.',
        features: ['Gestion des Appareils Mobiles','Développement d\'Applications d\'Entreprise','Solutions BYOD','Sécurité Mobile','Applications Multi-plateformes','Capacités Hors Ligne'],
        industries: ['Santé','Commerce de Détail','Finance','Logistique','Fabrication'],
      },
      iot: {
        title: 'Développement IoT',
        description: 'Connectez vos appareils et débloquez de nouvelles possibilités avec nos solutions IoT.',
        features: ['Intégration d\'Appareils','Surveillance en Temps Réel','Analyse de Données','Connectivité Cloud','Edge Computing','Maintenance Prédictive'],
        industries: ['Villes Intelligentes','Agriculture','Énergie','Transport','Santé'],
      },
      desktop: {
        title: 'Solutions Logicielles de Bureau',
        description: 'Applications de bureau puissantes conçues pour la performance et la fiabilité.',
        features: ['Performance Native','Fonctionnalité Hors Ligne','UI/UX Avancée','Intégration Système','Support Multi-plateforme','Fonctionnalités d\'Entreprise'],
        industries: ['Finance','Ingénierie','Design','Éducation','Santé'],
      },
      mobileWeb: {
        title: 'Développement Mobile et Web',
        description: 'Créez des expériences numériques engageantes avec nos services de développement mobile et web.',
        features: ['Design Responsive','Applications Web Progressives','Applications Mobiles Natives','Intégration API','Fonctionnalités en Temps Réel','Déploiement Cloud'],
        industries: ['E-commerce','Médias','Éducation','Voyage','Divertissement'],
      },
    },
    process: {
      title: 'Notre Processus de Mise en Œuvre',
      subtitle: 'Une méthodologie éprouvée pour fournir des solutions réussies',
      steps: {
        discovery: { title: 'Découverte', description: 'Nous analysons vos besoins et définissons les exigences du projet' },
        design: { title: 'Conception', description: 'Créer des designs centrés sur l\'utilisateur et une architecture technique' },
        development: { title: 'Développement', description: 'Construire et tester votre solution avec une méthodologie agile' },
        deployment: { title: 'Déploiement', description: 'Lancer et fournir un support et une maintenance continus' },
      },
    },
  },

  // Blog Page
  blog: {
    title: 'Notre',
    titleHighlight: 'Blog',
    subtitle: 'Perspectives, mises à jour et leadership éclairé sur la transformation numérique et la technologie',
    categories: {
      all: 'Tout',
      technology: 'Technologie',
      business: 'Affaires',
      development: 'Développement',
      security: 'Sécurité',
      cloud: 'Cloud',
      marketing: 'Marketing',
    },
    readMore: 'Lire Plus',
    loadMore: 'Charger Plus d\'Articles',
    newsletter: {
      title: 'Abonnez-vous à Notre Newsletter',
      description: 'Recevez les dernières informations et mises à jour dans votre boîte de réception',
      placeholder: 'Entrez votre email',
      button: 'S\'abonner',
      consent: 'J\'accepte de recevoir des emails',
      success: 'Merci pour votre inscription !',
      error: 'Impossible de s\'abonner. Veuillez réessayer.',
    },
  },

  // Contact Page
  contact: {
    title: 'Entrer en',
    titleHighlight: 'Contact',
    subtitle: 'Discutons de la façon dont nous pouvons aider à transformer votre entreprise avec nos solutions numériques',
    info: {
      locations: { title: 'Nos Emplacements', lubumbashi: 'Lubumbashi, RD Congo', kolwezi: 'Kolwezi, RD Congo' },
      email: { title: 'Envoyez-nous un Email' },
      phone: { title: 'Appelez-Nous' },
    },
    form: {
      title: 'Envoyez-Nous un Message',
      name: 'Nom Complet',
      email: 'Adresse Email',
      phone: 'Numéro de Téléphone',
      company: 'Nom de l\'Entreprise',
      service: 'Service Intéressé',
      selectService: 'Sélectionnez un service',
      message: 'Message',
      messagePlaceholder: 'Parlez-nous de votre projet...',
      characters: 'caractères',
      required: '*',
      sending: 'Envoi en cours...',
      send: 'Envoyer le Message',
      success: 'Merci ! Votre message a été envoyé avec succès.',
      error: 'Quelque chose s\'est mal passé. Veuillez réessayer.',
    },
    services: ['Développement de Logiciels','Support Informatique','Marketing Numérique','Développement d\'Applications Mobiles','Solutions IoT','Services Cloud','Autre'],
    visit: {
      title: 'Visitez Notre Bureau',
      description: 'Nous sommes situés à Lubumbashi et Kolwezi. N\'hésitez pas à nous rendre visite ou à planifier une réunion.',
    },
    hours: {
      title: 'Heures d\'Ouverture',
      weekdays: 'Lundi - Vendredi',
      weekdaysTime: '8h00 - 18h00',
      saturday: 'Samedi',
      saturdayTime: '9h00 - 14h00',
      sunday: 'Dimanche',
      sundayTime: 'Fermé',
    },
  },

  // Footer
  footer: {
    description: 'Principal fournisseur de solutions numériques à Lubumbashi, spécialisé dans le développement de logiciels sur mesure, les applications web et mobiles, et les services de conseil informatique.',
    quickLinks: 'Liens Rapides',
    services: 'Services',
    contact: 'Nous Contacter',
    followUs: 'Suivez-Nous',
    rights: 'Tous droits réservés.',
  },
};

export default fr;
